import { render } from "./Image.vue?vue&type=template&id=2db27670&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=2db27670&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db27670"]])

export default __exports__